<i18n>
{
  "cl":{
    "cliente": "Cliente",
    "otros": "Otros"
  }
}
</i18n>
<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <div class="collectings-card-header" />
      <div class="card-item mt-6 select-content">
        <div id="header-buttons" class="buttons is-centered">
          <button id="button-filter" class="button is-button-secondary is-rounded" @click="filtersModal = true">
            <span class="icon is-small">
              <i class="fas fa-filter" />
            </span>
            <span>Filtrar</span>
          </button>
          <button
            id="button-excel"
            class="button block is-button-secondary is-rounded"
            :disabled="collectingsByFilters.length < 1 || !checkUserFeature('element.collectings.button.excel')"
            @click="downloadExcel">
            <span class="icon is-small">
              <i class="far fa-file-excel" />
            </span>
            <span>Excel</span>
          </button>
        </div>
        <div v-if="!collectingsByFilters.length" class="message-info has-text-centered">
          <i class="fas fa-exclamation-circle is-pulled-left" />
          <div class="message-text">
            <span>
              No hay recaudaciones que cumplan con los valores introducidos en el filtro,
              vuelve a filtrar para obtener resultados.
            </span>
            <span>
              Hay {{ collectingsByFilters.length }} recaudaci{{ collectingsByFilters.length !== 1 ? 'ones' : 'ón' }}
              , estás viendo {{ collectingsByFilters.length }}.
            </span>
          </div>
        </div>
        <div class="investor-content">
          <div v-for="(items, i) in collectingsByFilters" :key="i" class="investor-item card-item shadowless">
            <div class="investor-item-info clearfix">
              <div class="text-info">
                <div class="text has-text-weight-bold title-label">{{ items.clientname }}</div>
                <span class="text">Nº de cuota: {{ items.paymentnumber }}</span>
                <div class="text">Vencimiento: {{ formatDate(items.duedate) }}</div>
                <div class="text">Fecha de pago: {{ formatDate(items.createdat) }}</div>
                <div class="fees-content" />
                <div class="details-content">
                  <a href="javascript:void(0);" @click.prevent="extended = (extended !== i) ? i : undefined">
                    <span v-html="extended === i ? 'Ocultar ' : 'Ver info '" />
                    <span class="fa fa-chevron-down transition-slow" :class="{ rotate: extended === i }" />
                  </a>
                </div>
              </div>
            </div>
            <div class="investor-details clearfix transition-slow" :class="{ show: extended === i }">
              <div class="pt-5">
                <div class="header-tabs">
                  <b-tabs v-model="selectedContent" expanded>
                    <b-tab-item
                      v-for="(value, content) in contentButtons"
                      :id="`${value}-data`"
                      :key="content"
                      :label="$t(value)"
                      :value="`${content}-data`" />
                  </b-tabs>
                </div>
                <div class="card-items-tabs">
                  <div v-if="selectedContent === 'client-data'" id="client-data">
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">RUT</span><br>
                        <span>{{ items.idnumber }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Estado</span><br>
                        <span>{{ items.status }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Inversor</span><br>
                        <span>{{ items.investor }}</span>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">CMF</span><br>
                        <span>{{ items.companyoperationid }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">N° cuenta inversor</span><br>
                        <span>{{ items.investorbankaccountnumber }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Medio pago</span><br>
                        <span>{{ items.provider }}</span>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">Fecha pago</span><br>
                        <span>{{ formatDate(items.providerat) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Fecha respuesta</span><br>
                        <span>{{ formatDate(items.callbackat) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Fecha de entrada bancaria</span><br>
                        <span>{{ formatDate(items.bankentrydate) }}</span>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">Fecha de proceso</span><br>
                        <span>{{ formatDate(items.processedat) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Fecha de cosignación</span><br>
                        <span>{{ formatDate(items.consignedat) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Saldo insoluto</span><br>
                        <span>{{ formatNumber(items.balance) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedContent === 'other-data'" id="other-data">
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">Interés de la cuota</span><br>
                        <span>{{ items.interest }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Amortización de la cuota</span><br>
                        <span>{{ items.amortization }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Monto del dividendo</span><br>
                        <span>{{ formatNumber(items.monthlypayment) }}</span>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">Seguro de vida del deudor</span><br>
                        <span>{{ items.debtorlifeinsurance }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Seguro de vida del codeudor</span><br>
                        <span>{{ items.codebtorlifeinsurance }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Seguro de incendios</span><br>
                        <span>{{ items.fireinsurance }}</span>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">Cargo por interés penal</span><br>
                        <span>{{ formatNumber(items.lateinterest) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Cobranza de penalización</span><br>
                        <span>{{ formatNumber(items.latecharges) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Monto total pagado</span><br>
                        <span>{{ formatNumber(items.totalmonthlypayment) }}</span>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <span class="title-label">UF</span><br>
                        <span>{{ formatNumber(items.secondarycurrencyfactor) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Total pagado</span><br>
                        <span>{{ formatNumber(items.secondarycurrencytotalmonthlypayment) }}</span>
                      </div>
                      <div class="column">
                        <span class="title-label">Retorno al inversionista</span><br>
                        <span>{{ formatNumber(items.secondarycurrencyconsignedamount) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CredituPagination
          :page-number.sync="paginationPage"
          size="is-small"
          :documents-per-page.sync="paginationPageLength"
          items-name="Recaudaciones"
          :total="paginationTotalDocuments"
          :range-before="1"
          :range-after="1"
          :documents-per-page-options="[5, 10, 20, 50]" />
      </div>
      <CollectingsFiltersModal v-model="filtersModal" :collectings="collectings" @filter="loadCollectings" />
    </div>
  </div>
</template>
<script>
import XlsxStreamWriter from 'xlsx-stream-writer';
import { formatNumber } from '@/infrastructure/format';
import CredituPagination from '@/ui/components/CredituPagination.vue';
import { getCollectings } from '@/application/services/api-clients/query-stack';
import userFeatures from '@/ui/mixins/user-features';
import Message from '@/ui/components/Message.vue';
import CollectingsFiltersModal from './CollectingsFiltersModal.vue';

export default {
  name: 'Collectings',
  components: { CredituPagination, CollectingsFiltersModal, Message },
  mixins: [userFeatures],
  data() {
    return {
      collectings: [],
      filtersModal: false,
      collectingsByFilters: [],
      extended: undefined,
      paginationPage: 1,
      paginationTotalDocuments: 0,
      paginationPageLength: 10,
      isActiveError: false,
      filterData: undefined,
      field_filters: {},
      isDowloadingExcel: false,
      contentButtons: {
        client: 'cliente',
        other: 'otros'
      },
      selectedContent: 'client-data'
    };
  },
  watch: {
    paginationPage: {
      immediate: true,
      async handler() {
        this.loadCollectings();
      }
    },
    paginationPageLength: {
      immediate: true,
      async handler() {
        this.loadCollectings();
      }
    }
  },
  async mounted() {
    await this.loadCollectings();
  },
  methods: {
    async loadCollectings(filters = this.field_filters) {
      try {
        const meta2 = {
          page: this.paginationPage,
          page_length: this.paginationPageLength
        };
        const search = {
          id: '',
          idnumber: '',
          clientname: filters.clientName,
          investor: filters.investor,
          informe: filters.report,
          investorbankaccountnumber: filters.accountInvestor,
          companyoperationid: '',
          provider: filters.cmf,
          status: filters.status,
          date_field: filters.typeDate,
          date_from: filters.from,
          date_to: filters.to
        };
        this.field_filters = search;
        const { meta, data } = await getCollectings(meta2, search);
        this.collectingsByFilters = data;
        this.paginationPage = meta.page;
        this.paginationTotalDocuments = meta.total;
      } catch (_error) {
        this.showError('Ocurrió un error al consultar las recaudaciones.');
      }
    },
    formatData(collecting) {
      const t = { ...collecting };
      const dateKeys = [
        'providerat',
        'callbackat',
        'bankentrydate',
        'processedat',
        'consignedat',
        'duedate',
        'createdat'
      ];
      const numberKeys = [
        'paymentnumber',
        'balance',
        'interest',
        'amortization',
        'monthlypayment',
        'debtorlifeinsurance',
        'codebtorlifeinsurance',
        'fireinsurance',
        'lateinterest',
        'latecharges',
        'totalmonthlypayment',
        'secondarycurrencyfactor',
        'secondarycurrencytotalmonthlypayment',
        'secondarycurrencyconsignedamount',
        'monthlycreditinsurance',
        'secondarycurrencymonthlycreditinsurance',
        'monthlyCreditInsurancePrize',
        'monthlyCreditInsuranceExpenses'
      ];
      dateKeys.forEach(key => {
        if (t[key]) {
          t[key] = new Date(t[key]) ? this.formatDate((new Date(t[key]))) : '';
        }
      });
      numberKeys.forEach(key => {
        if (t[key]) {
          t[key] = t[key] !== null && t[key] !== undefined ? `="${t[key]}"` : null;
        }
      });
      return t;
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async processDataForExcel() {
      const rowsPerChunk = 10000;
      const btnExcel = document.querySelector('#button-excel');
      if (btnExcel) {
        btnExcel.classList.add('button-excel-downloading');
      }
      const excelCollectings = [];
      const { meta: { total } } = await getCollectings({ page_length: 1 }, this.field_filters);
      const maxPages = total > rowsPerChunk ? Math.ceil(total / rowsPerChunk) : 1;
      /* eslint-disable no-await-in-loop */
      for (let page = maxPages; page > 0; page -= 1) {
        const { data } = await getCollectings({ page_length: rowsPerChunk, page }, this.field_filters);
        const percentage = 100 - ((100 / maxPages) * (page - 1));
        excelCollectings.push(...data);
        if (btnExcel) {
          const per = Math.ceil(percentage);
          btnExcel.style.background = `linear-gradient(90deg, rgba(158,255,155,0.5) 0%, rgba(158,255,155,0.5) ${per - 1}%, rgba(255,255,255,0.5) ${per}%, rgba(255,255,255,0.5) 100%)`;
          btnExcel.innerHTML = `Excel (${percentage.toFixed(2)}%)`;
        }
      }
      /* eslint-enable no-await-in-loop */
      return excelCollectings.map(collecting => this.formatData(collecting));
    },
    async downloadExcel() {
      if (this.isDowloadingExcel) {
        this.showError('Ya hay una exportación en proceso.');
        return;
      }
      this.showNotification('Descargando archivo Excel...');
      this.isDowloadingExcel = true;
      const btnExcel = document.querySelector('#button-excel');
      btnExcel.style.background = 'rgba(255,255,255,0.5)';
      btnExcel.innerHTML = 'Excel (0.00%)';
      const rows = await this.processDataForExcel();
      const headers = [
        'id',
        'idnumber',
        'informe',
        'clientname',
        'investor',
        'investorbankaccountnumber',
        'companyoperationid',
        'paymentnumber',
        'provider',
        'status',
        'duedate',
        'createdat',
        'providerat',
        'callbackat',
        'bankentrydate',
        'processedat',
        'consignedat',
        'balance',
        'interest',
        'amortization',
        'monthlypayment',
        'debtorlifeinsurance',
        'codebtorlifeinsurance',
        'fireinsurance',
        'lateinterest',
        'latecharges',
        'totalmonthlypayment',
        'secondarycurrencyfactor',
        'secondarycurrencytotalmonthlypayment',
        'secondarycurrencyconsignedamount',
        'monthlycreditinsurance',
        'secondarycurrencymonthlycreditinsurance',
        'creditinsuranceinvestor',
        'creditinsuranceinvestorbankaccountnumber',
        'monthlycreditinsuranceisconsigned',
        'monthlycreditinsuranceconsignedat'
      ];
      this.showNotification('Descarga completada. Procesando datos...');
      const data = rows.map(row => headers.map(header => row[header] || ''));
      await this.wait(1000);
      btnExcel.style.background = 'rgba(255,255,255,0.5)';
      btnExcel.innerHTML = 'Excel (100.00%)';
      const xlsx = new XlsxStreamWriter();
      xlsx.addRows(data);
      this.showNotification('Tu archivo Excel está siendo guardado en tu computadora. Por favor espere un momento.');
      await this.wait(1000);
      let csv = '';
      headers.forEach(header => {
        const escapedHeader = `${header}`.split(';').join('');
        csv += `${escapedHeader};`;
      });
      csv = csv.slice(0, -1);
      csv += '\n';
      data.forEach(row => {
        row.forEach(cell => {
          const escapedCell = `${cell}`.split(';').join('');
          csv += `${escapedCell};`;
        });
        csv = csv.slice(0, -1);
        csv += '\n';
      });
      const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const today = new Date();
      a.download = `Recaudaciones_${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      this.isDowloadingExcel = false;
      this.showNotification('Archivo Excel guardado en tu computadora.');
    },
    formatDate: date => {
      if (date == null) {
        return '';
      }
      return new Date(date).toISOString().substring(0, 10).split('-')
        .reverse()
        .join('/');
    },
    formatNumber: number => formatNumber({ number }),
    showNotification(mensaje) {
      this.$buefy.notification.open({
        duration: 3000,
        message: mensaje,
        type: 'is-success is-light',
        hasIcon: true
      });
    },
    showError(mensaje) {
      this.$buefy.notification.open({
        duration: 3000,
        message: mensaje,
        type: 'is-danger',
        hasIcon: true
      });
    }
  }
};
</script>
<style lang="css" scoped>
.button-excel-downloading {
  color: var(--primary);
}

.button-excel-downloading:hover {
  color: #006966;
}

.investor-payments-card-header {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
}

.message-info {
  display: grid;
  grid-template-columns: 1fr 10fr;
  gap: 1rem;
  align-items: center;
  background: #F2FBFB;
  padding: 20px;
  margin: 0.5rem 0rem 2rem 0rem;
  border-radius: 20px;
  font-family: var(--secondary-font);
  color: var(--color-nickel);
}

.message-info i {
  color: var(--primary);
}

.confirmed-data {
  display: grid;
  grid-gap: 1rem;
  grid-template:
    1fr
    / 1fr 1fr 1fr 1fr;
  text-align: center;
  font-size: 0.8rem;
  margin-top: 1rem;
}

.item {
  display: grid;
  grid-gap: 0.5rem;
  grid-template:
    1fr 1fr
    / 1fr;
  text-align: center;
  font-size: 0.8rem;
}

.item-header {
  color: var(--primary);
}

.confirm-button {
  padding: 10px;
  height: auto;
  border-radius: 20px;
  border: inherit;
  font-size: 10px;
  text-decoration: none;
  font-weight: 400;
  font-family: var(--primary-font);
  margin-top: 20px;
}

.button-disabled {
  opacity: 40%
}

.spinner-content {
  margin-top: 80px;
}

.select-content {
  width: 95%;
  margin: 30px auto 50px;
  padding-bottom: 50px;
  ;
  overflow: inherit;
}

.table-content {
  width: 95%;
  margin: 30px auto 50px;
}

.b-table .table-wrapper.has-sticky-header {
  height: auto;
}

.investor-item {
  padding: 14px 29px;
  margin: 20px auto;
  border-radius: 25px;
  position: relative;
  overflow: inherit;
  width: 100%;
}

.text-info {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
}

.rotate {
  transform: rotate(180deg);
}

.name-content {
  color: var(--primary);
  font-size: 18px;
  font-weight: 600;
}

.status-content {
  color: var(--primary);
  font-size: 15px;
  font-weight: 600;
  padding: 5px;
  background-color: rgb(3, 169, 164, 0.2);
  border-radius: 25px;
}

.amount-content a {
  display: inline-block;
  margin-left: 15px;
}

.investor-details {
  width: 100%;
  max-height: 0px;
  height: auto;
  overflow: hidden;
  margin: auto;
}

.investor-details.show {
  max-height: 400px;
}

.investor-column {
  width: 50%;
  float: left;
}

.table-data {
  width: 100%;
  font-size: 11px;
  vertical-align: bottom !important;
}

.table-data tr td:first-child {
  color: var(--primary);
  width: 40%;
}

table .important-color {
  color: var(--secondary);
  font-size: 14px;
}

.round-choice-content {
  width: 25px;
  float: left;
}

.details-content {
  float: right;
}

.details-content a {
  text-decoration: none;
  font-size: 16px;
}

.shaking {
  animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.disabledShakeButton {
  color: var(--color-nickel);
  cursor: not-allowed;
}

.title-label {
  color: #00CCD1;
}

.header-tabs {
  width: 100%;
  background: #fff;
  border-radius: 20px 20px 0 0;
  border: 1px solid #CCC;
  border-bottom: none;
  height: 41px;
}

.card-items-tabs {
  overflow: hidden;
  padding: 20px;
  border-radius: 0 0 20px 20px;
  border: 1px solid #CCC;
  margin-bottom: 10px;
}

@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

@media (max-width: 1250px) {
  .text-item-info {
    width: 30%;
  }

  .text-item-info:first-child {
    width: 50%;
  }

  .details-content a span:first-child {
    display: none;
  }
}

@media (max-width: 850px) {
  .text-item-info {
    white-space: nowrap;
  }

  .investor-column {
    float: none;
    width: 100%;
  }

  .table-data tr td:first-child {
    width: 50% !important;
  }

  div .card-items-tabs {
    overflow-y: auto;
    max-height: 200px;
  }
}

@media (max-width: 640px) {
  .text-info {
    display: block;
    text-align: center;
  }

  .text-item-info {
    width: 100%;
    margin-bottom: 10px;
  }

  .round-choice-content {
    position: absolute;
    width: 35px;
    height: 35px;
    right: 20px;
    top: 20px;
  }

  .details-content {
    text-align: center;
    width: 100%;
  }

  .table-data {
    font-size: 9px;
  }

  .table-data .tr .td:nth-child(2)::before {
    content: "\A";
  }

  .confirmed-data {
    display: grid;
    grid-gap: 0.5rem;
    grid-template:
      1fr 1fr 1fr 1fr
      / 1fr;
    text-align: center;
    font-size: 0.8rem;
  }

  .item {
    display: grid;
    grid-gap: 0.5rem;
    grid-template:
      1fr
      / 1fr 1fr;
    text-align: left;
    font-size: 0.8rem;
  }
}
</style>
